import { render } from "./RenderingAListOfData.vue?vue&type=template&id=07b33c12"
import script from "./RenderingAListOfData.vue?vue&type=script&lang=js"
export * from "./RenderingAListOfData.vue?vue&type=script&lang=js"

import "./RenderingAListOfData.vue?vue&type=style&index=0&id=07b33c12&lang=css"
script.render = render

export default script